const SCROLL_OPTIONS: ScrollIntoViewOptions = {
   behavior: 'smooth',
   block: 'end',
};

export const scrollToElement = <T extends Element>(element: React.MutableRefObject<T | null>) =>
   setTimeout(() => element.current?.scrollIntoView(SCROLL_OPTIONS), 300);
